import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';

import { api } from '@/api';
import { DeleteAction, EditAction } from '@/components/table/actions';
import { ProductIcon } from '@/components/icons';
import { getColumnSearchFields } from '@/components/table/filters';
import { PERMISSION_OBJ_PRODUCT, PERMISSION_DELETE, PERMISSION_UPDATE } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { productStore } from '@/stores';
import { ProductType } from '@/types/enums';
import { buildFilterOptionsFromEnum, showError } from '@/utils/common';

const PermissionedEditAction = withPermissions([[PERMISSION_OBJ_PRODUCT, PERMISSION_UPDATE]])(EditAction);
const PermissionedDeleteAction = withPermissions([[PERMISSION_OBJ_PRODUCT, PERMISSION_DELETE]])(DeleteAction);

const Actions = (_: any, record: any) => {
  const onDelete = () => {
    api.products
      .delete(record.id)
      .source.then(() => productStore.deleteItem(record.id))
      .catch(showError);
  };

  return (
    <Space>
      <PermissionedEditAction uiSref={{ to: 'base-layout.products.edit', params: { productId: record.id } }} />
      <PermissionedDeleteAction onConfirm={onDelete} />
    </Space>
  );
};

export const columns = [
  {
    dataIndex: 'id',
    sorter: false,
    width: 50,
    render: (_, record) => <ProductIcon type={record.type} />,
  },
  {
    title: <FormattedMessage id="products.name" />,
    dataIndex: 'name',
    ...getColumnSearchFields(),
  },
  {
    title: <FormattedMessage id="products.type" />,
    dataIndex: 'type',
    filterMultiple: false,
    filters: buildFilterOptionsFromEnum(ProductType),
    render: (_, record) => <FormattedMessage id={`products.type.${record?.type}`} />,
  },
  {
    title: <FormattedMessage id="products.sampling-method" />,
    dataIndex: 'samplingMethod',
    ...getColumnSearchFields(),
  },
  {
    title: '',
    render: Actions,
    className: 'actions',
  },
];
